// Variables para el cambio de peticiones en enlace
let api_requests = {
  development: "http://localhost:5006",
  test: "https://apisalas.tmoneysport.com",
  production: "",
};

export const token_name = "ssidbrenner"; // Codigo del token para descifrar y encryptar
export const host3 = api_requests.test; // Enlace a host de api
